import script from "./comp_elemento_lista_alojamiento.vue?vue&type=script&setup=true&lang=js"
export * from "./comp_elemento_lista_alojamiento.vue?vue&type=script&setup=true&lang=js"

import "./comp_elemento_lista_alojamiento.vue?vue&type=style&index=0&id=039a0b72&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-039a0b72"]])

export default __exports__